/**
 * Created by eriksundqvist on 12/10/16.
 */

export default class InvoicePostEntity {

  constructor (
    specification,
    userId,
    taxId,
    companyId,
    currencyId,
    currencyName,
    amount,
    invoiceUsers,
    invoiceDates,
    preReport,
    preReportedAt,
    createdAt,
    hsd,
    sendToEmail,
    sendToEinvoiceAddress,
    displayDates,
    displayHours,
    couponId,
    currencyAmount,
    messageType
  ) {
    this.specification = specification;
    this.userId = userId;
    this.taxId = taxId;
    this.companyId = companyId;
    this.currencyId = currencyId;
    this.currencyName = currencyName;
    this.amount = amount;
    this.invoiceUsers = invoiceUsers;
    this.invoiceDates = invoiceDates;
    this.preReport = preReport;
    this.preReportedAt = preReportedAt;
    this.createdAt = createdAt;
    this.hsd = hsd;
    this.sendToEmail = sendToEmail;
    this.sendToEinvoiceAddress = sendToEinvoiceAddress;
    this.displayHours = displayHours;
    this.displayDates = displayDates;
    this.couponId = couponId || '';
    this.currencyAmount = currencyAmount;
    this.messageType = messageType;
  }
}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/invoices/invoice-post-entity.js
 **/